import React, { useState } from "react";
import { classIf } from '../../data/utils/classIf';
import { formatDate } from '../../data/utils/formatDate';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencyValue } from '../../data/utils/getCurrencyValue';
import { oddToString } from '../../data/utils/oddToString';
import { getLabel } from "../../data/labels";

export default function BetOptionModalContentWrapper(props) {
	return props.betOptionsData.isBetclic? BetOptionsModalContentBetclic({...props}) : BetOptionsModalContent({...props});
}

function BetOptionsModalContentBetclic(props) {
	const conf = getConfiguration();
	const nDec = conf.cs.nd;
	const mult = conf.cs.m;
	const currency = conf.cs.ct;
	
	const checkedValue = props.betOptionsData.checkedValue;
	const betOptionsData = props.betOptionsData.options;
	const selectorFunction = props.betOptionsData.selectorFunction;
	const type = props.betOptionsData.type;
	const [preSelectedBonus, setPreSelectedBonus] = useState(null);
	
	function togglePreSelector(betOption) {
		if (betOption.id_bonus === preSelectedBonus?.id_bonus) {
			setPreSelectedBonus(null);
		} else {
			setPreSelectedBonus(betOption);
		}
	}
	
	function selectWagering() {
	    props.closeFunction();
    	selectorFunction(preSelectedBonus.id_bonus, type);
    }

	return (
		<div className="c_45">
			<div className="c_45_1">
				{type === 'funbonus' &&
					<>
						<div className="c_45_1_2"> {getLabel('mybets.funbonus')} </div>
					</>
				}
				{type === 'freebet' &&
					<>
						<div className={"c_45_1_3"}><span className="c_45_1_3_1"></span></div>
						<div className="c_45_1_2"> {getLabel('mybets.freebet')} </div>
					</>			
				}
			</div>
			<div className="c_45_2">
				{betOptionsData.map(function(betOption) {
					const reactKey =  "bonus-" + betOption.id_bonus;
					const selected = preSelectedBonus?.id_bonus === betOption.id_bonus;
					return (
						<div className="c_45_2_1" key={"bet-option-" + reactKey}>
							<input  onChange={() => {togglePreSelector(betOption);}}  type="checkbox" className="c_45_2_1_1" checked={selected} />
							<div className={"c_45_2_1_1_2" + classIf(selected, 'selected')}>
							{betOption.descrizione_promo ? betOption.descrizione_promo : `${betOption.sigla_promo} - ${betOption.id_bonus}`}
							</div>
						</div>
					);
				})}
			</div>
			{preSelectedBonus && <div className="c_45_3" onClick={selectWagering}> {getLabel('live.fastbet_popup.confirm')} </div>}
			<div className="c_45_4">
				<div className="c_45_4_1">
					{preSelectedBonus &&
						<>
							{preSelectedBonus.importo &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{type === 'funbonus'? getLabel('betslip.fun_bonus.remaining_balance') : getLabel('betslip.freebet.total_amount')}</span>
									<span className="c_45_4_1_1_1">{getCurrencyValue(preSelectedBonus.importo, mult, nDec, currency)}</span>
								</div>				
							}
							{preSelectedBonus.rollover && type === 'funbonus' &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{getLabel('wagering.rollover')}</span>
									<span className="c_45_4_1_1_1">{preSelectedBonus.rollover}</span>
								</div>				
							}
							{preSelectedBonus.json_raccolta?.sport?.min_eve &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{getLabel("wagering.label_min_selections")}</span>
									<span className="c_45_4_1_1_1">{preSelectedBonus.json_raccolta.sport.min_eve}</span>
								</div>				
							}
							{preSelectedBonus.json_raccolta?.sport?.tot_odd > 100 &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{getLabel("wagering.label_min_tot_odd")}</span>
									<span className="c_45_4_1_1_1">{oddToString(preSelectedBonus.json_raccolta.sport.tot_odd)}</span>
								</div>				
							}
							{preSelectedBonus.json_raccolta?.sport?.min_odd > 100 &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{getLabel("wagering.label_min_tot_odd_per_sel")}</span>
									<span className="c_45_4_1_1_1">{oddToString(preSelectedBonus.json_raccolta.sport.min_odd)}</span>
								</div>				
							}
							{preSelectedBonus.min_bet && type === 'funbonus' &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{getLabel('betslip.fun_bonus.min')}</span>
									<span className="c_45_4_1_1_1">{getCurrencyValue(preSelectedBonus.min_bet, mult, nDec, currency)}</span>
								</div>				
							}
							{preSelectedBonus.max_bet && type === 'funbonus' &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{getLabel('betslip.fun_bonus.max')}</span>
									<span className="c_45_4_1_1_1">{getCurrencyValue(preSelectedBonus.max_bet, mult, nDec, currency)}</span>
								</div>				
							}
							{preSelectedBonus.json_raccolta?.sport?.prematch !== null &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{getLabel('menu.prematch')}</span>
									<span className="c_45_4_1_1_1">{preSelectedBonus.json_raccolta.sport.prematch? 'Sì' : 'No'}</span>
								</div>				
							}
							{preSelectedBonus.json_raccolta?.sport?.live !== null &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{getLabel('menu.live')}</span>
									<span className="c_45_4_1_1_1">{preSelectedBonus.json_raccolta.sport.live? 'Sì' : 'No'}</span>
								</div>				
							}
							{preSelectedBonus.json_raccolta?.sport?.two_way_market !== null &&
								<div className="c_45_4_1_1">
									<span className="c_45_4_1_1_1">{getLabel("wagering.label_two_way_market")}</span>
									<span className="c_45_4_1_1_1">{preSelectedBonus.json_raccolta.sport.two_way_market? 'Sì' : 'No'}</span>
								</div>				
							}
							{preSelectedBonus.data_fine_raccolta &&
								<>
									<div className="c_45_4_1_1">
										<span className="c_45_4_1_1_1">{getLabel("wagering.expire_date")}</span>
										<span className="c_45_4_1_1_1">{formatDate(preSelectedBonus.data_fine_raccolta).formatted}</span>
									</div>
									<div className="c_45_4_1_2">
										{getLabel('wagering.max_date_error').replaceAll("{{DATE}}", formatDate(preSelectedBonus.data_fine_raccolta).formatted) } 
									</div>	
								</>			
							}						
						</>
					}
				</div>
			</div>
		</div>
	);
}

function BetOptionsModalContent(props) {
    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;
    
    const checkedValue = props.betOptionsData.checkedValue;
    const betOptionsData = props.betOptionsData.options;
    const selectorFunction = props.betOptionsData.selectorFunction;
    const type = props.betOptionsData.type;
    
    function selectRadio(value) {
    	selectorFunction(value, type);
    	props.closeFunction();
    }
 
    return (
		<div className="bonus-schedina_template-1">
			<div className="bonus-schedina_template-1_body">
				<div className="bet-options-selectors-container">
					{type === 'freebet' &&
						<>
							<div className="bonus-schedina_template-1_body_title">
								<p><span>{getLabel('betslip.freebet.title_part2')}</span></p>
							</div>
							{betOptionsData.map(function(betOption) {
								const reactKey =  "bonus-" + betOption.id_bonus;
								return (
									<div key={"bet-option-" + betOption.id_bonus} className={"bonus-schedina_template-1_body_card" + (betOption.importo > 0 ? '' : 'd-none')}>
										<div className="bonus-schedina_template-1_body_card_title">
											<p>{betOption.sigla_promo} - {betOption.id_bonus}</p>
											<input checked={checkedValue.value == betOption.id_bonus + ""} 
												onChange={() => {selectRadio(betOption.id_bonus + "", betOption.type)}} 
												type="radio" 
												className="pointer" 
												name={reactKey}
												key={reactKey}
												value={reactKey} />
										</div>
										<div>
											<p>{getLabel('betslip.freebet.total_amount')} <span className="grassetto">{getCurrencyValue(betOption.importo, mult, nDec, currency)} </span></p>
										</div>
									</div>
								);
							})}
						</>
					}
					{type === 'funbonus' &&
						<>
							<div className="bonus-schedina_template-1_body_title">
								<p><span>{getLabel('betslip.fun_bonus.title_part2')}</span></p>
							</div>      
							{betOptionsData.map(function(betOption) {
								const perc = (betOption.importo_giocato * 100) / betOption.importo_da_giocare;
								const reactKey = "bonus-" + betOption.id_bonus;
								return (
									<div key={"bet-option-" + betOption.id_bonus} className={"bonus-schedina_template-1_body_card" + (betOption.importo > 0 ? '' : 'd-none')}>
										<div className="bonus-schedina_template-1_body_card_title">
											<p>{betOption.sigla_promo}</p>
											<input checked={checkedValue.value == betOption.id_bonus + ""} 
												onChange={() => {selectRadio(betOption.id_bonus + "", betOption.type)}} 
												type="radio" 
												className="pointer" 
												name={reactKey}
												key={reactKey}
												value={reactKey} />
										</div>
										<div>
											<p>{getLabel('betslip.fun_bonus.remaining_balance')} {getCurrencyValue(betOption.importo, mult, nDec, currency)}</p>
										</div>
										<div className="bonus-schedina_template-1_body_card_progress progress">
											<div className="progress-bar" role="progressbar" style={{ width: perc + '%'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
											<p className="bonus-schedina_template-1_body_card_progress_text">
												{getCurrencyValue(betOption.importo_giocato, mult, nDec, currency)}
												/ 
												{getCurrencyValue(betOption.importo_da_giocare, mult, nDec, currency)} 
											</p>
										</div>
										<div className="bonus-schedina_template-1_body_card_range">
											<p>{getLabel('betslip.fun_bonus.min')} {getCurrencyValue(betOption.min_bet, mult, nDec, currency)}</p>
											<p>{getLabel('betslip.fun_bonus.max')} {getCurrencyValue(betOption.max_bet, mult, nDec, currency)}</p>
										</div>
									</div>
								);
							})}
						</>
					}
				</div>
			</div>
		</div>
	);
}
